module.exports = __webpack_public_path__ + "img/enterprise_wx.3f0a0f3d.svg";